import { fDate } from '@/utils/date.js'
import { Icon } from '@iconify/react'

export const CreativeActivityLog = ({ creative }) => {
  return (
      <div>
          <div className="text-sm font-light mt-2 flex gap-2 items-center">
              {
                  creative.origin === 'Meta' && <Icon icon="logos:meta-icon"/>
              }
              {creative.origin === 'Meta' ? 'Synced from Meta on: ' : 'Created:'}
              {fDate(creative.createdAt)}
          </div>
      </div>
  )
}